import { useReduxState } from 'hooks';
import { useApiData } from 'lib/api';
import { getMergedCompetencies } from 'lib/competencies';
import { LinkButton } from 'components/common';
import { Box } from 'components/common/box';

import type { GetUsersRes } from 'shared-types/responses';

interface Props {
  isUserPage?: boolean;
}

const ProfileSummaryCompetencies = ({ isUserPage }: Props) => {
  const {
    messages,
    pageState: { user }
  } = useReduxState();

  const { data: userData, loading } = useApiData<GetUsersRes>({
    onlyIf: Boolean(user?.id),
    url: `/admin/users?id=${user?.id}`
  });

  const mergedCompetencies = getMergedCompetencies(
    userData?.users?.[0]?.competencies || []
  );

  return (
    <Box
      headerContent={
        <LinkButton
          category="lighter"
          href={
            isUserPage
              ? `/users/${user?.id}/competencies`
              : '/profile/competencies'
          }
          size="header"
          text={messages.commonShowAll}
        />
      }
      headerContentWrap={true}
      loading={loading}
      title={messages.commonCompetencies}
      {...(!loading ? { titleCount: mergedCompetencies.length } : {})}
    />
  );
};

export default ProfileSummaryCompetencies;
